/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

export const formatToRgb = (color) => {
  const isPlainRgbFormat = /^\d+,\s*\d+,\s*\d+$/.test(color);
  const isPlainRgbaFormat = /^\d+,\s*\d+,\s*\d+,\s*[0-1](\.\d+)?$/.test(color);

  if (color.startsWith("var(--")) {
    const computedColor = getComputedStyle(document.documentElement).getPropertyValue(color.slice(4, -1)).trim();
    return formatToRgb(computedColor);
  }

  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const r = parseInt(hex.length === 3 ? hex[0] + hex[0] : hex.substring(0, 2), 16);
    const g = parseInt(hex.length === 3 ? hex[1] + hex[1] : hex.substring(2, 4), 16);
    const b = parseInt(hex.length === 3 ? hex[2] + hex[2] : hex.substring(4, 6), 16);

    return {
      rgb: `${r}, ${g}, ${b}`,
      rgba: `${r}, ${g}, ${b}, 1`,
    };
  }

  if (color.startsWith("rgba")) {
    const values = color.replace(/[^\d,]/g, "").split(",");
    return {
      rgb: values.slice(0, 3).join(","),
      rgba: values.join(","),
    };
  }

  if (color.startsWith("rgb") && !color.startsWith("rgba")) {
    const rgbValue = color.replace(/[^\d,]/g, "");
    return {
      rgb: rgbValue,
      rgba: `${rgbValue},1`,
    };
  }

  if (isPlainRgbFormat) {
    return {
      rgb: color,
      rgba: `${color}, 1`,
    };
  }

  if (isPlainRgbaFormat) {
    const values = color.split(",");

    return {
      rgb: values.slice(0, 3).join(","),
      rgba: color,
    };
  }

  return {
    rgb: color,
    rgba: `${color}, 1`,
  };
};